module.exports = __webpack_public_path__ + "src/images/art-dot-com.1fc2009aac274f62bf4281f8cfd584d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/art-dot-com.jpg
// module id = 116
// module chunks = 0